export const MY_FORMATS = {
  parse: {
    dateInput: ['l', 'll', 'L', 'LL', 'YYYY-MM-DD', 'MMM DD']
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

export function dateToString(dateValue: string): string {
  if (!dateValue) {
    return '';
  } else {
    const longDateString = dateValue.toString();
    const dateArray = longDateString.split(' ');
    const dateString =
      dateArray[2] +
      '/' +
      getMonthFromString(dateArray[1]) +
      '/' +
      dateArray[3];
    return dateString;
  }
}

function getMonthFromString(month: string) {
  const d = Date.parse(month + 1);
  if (!isNaN(d)) {
    const date = new Date(d).getMonth() + 1;
    if (date < 10) {
      return '0' + date;
    } else {
      return date;
    }
  }
  return -1;
}
